"use client";

import { useOptionalDatabase } from "@/context/DatabaseContext";
import { isProductionModeEnabled } from "@/utils/helpers/production-mode";
import React from "react";
import { DatabaseToggle } from "./navbar/databaseToggle";

export const BreakpointDisplay: React.FC = () => {
  const databaseContext = useOptionalDatabase();

  if (!databaseContext) {
    return null;
  }

  const { currentDatabase } = databaseContext;

  // Hide breakpoint display when production mode is enabled
  if (isProductionModeEnabled()) {
    return null;
  }

  // Determine background color based on database environment
  const getBackgroundColor = () => {
    if (currentDatabase === "production") {
      return "bg-red-500/50 backdrop-blur-sm";
    }
    if (currentDatabase === "local") {
      return "bg-green-500/40 backdrop-blur-sm";
    }
    return "";
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex justify-between items-center ${getBackgroundColor()}`}
    >
      {currentDatabase === "local" ? (
        <div className="flex flex-1">
          <div className="hidden sm:block bg-blue-500 px-2 text-sm">
            sm: 640px
          </div>
          <div className="hidden md:block bg-green-500 px-2 text-sm">
            md: 768px
          </div>
          <div className="hidden lg:block bg-yellow-500 px-2 text-sm">
            lg: 1024px
          </div>
          <div className="hidden xl:block bg-red-500 px-2 text-sm">
            xl: 1280px
          </div>
          <div className="hidden 2xl:block bg-purple-500 px-2 text-sm">
            2xl: 1536px
          </div>
        </div>
      ) : (
        <div className="flex-1"></div>
      )}
      <div className="flex items-center">
        <DatabaseToggle />
      </div>
      <div className="flex-1"></div>
    </div>
  );
};
